import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

export interface ModalReturnHistoryStoreInterface {
  collectionId: number
  collectionNo: string
  onClickLinkCallback?: (userId: string) => void
}

@Module({
  name: 'ModalReturnHistoryStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalReturnHistoryStore extends BaseStore {
  _isOpen: boolean = false

  _collectionId: number = 0

  _collectionNo: string = ''

  _linkCallback?: (userId: string) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get collectionId(): number {
    return this._collectionId
  }

  get collectionNo(): string {
    return this._collectionNo
  }

  @Mutation
  public open(params: ModalReturnHistoryStoreInterface) {
    this._isOpen = true
    this._collectionId = params.collectionId
    this._collectionNo = params.collectionNo
    this._linkCallback = params.onClickLinkCallback
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }

  @Mutation
  public link(userId: string) {
    if (this._linkCallback) {
      this._linkCallback(userId)
    }
  }
}
